import http from "../utils/axiosInstance";

class mediaDataService {
  create(data) {
    return http.post(`/media`, data);
  }

  getAll() {
    return http.get(`/media`);
  }
  delete(id) {
    return http.delete(`/media/${id}`);
  }
  update(id, data) {
    return http.put(`/media/${id}`, data);
  }
  single(id) {
    return http.get(`/media/${id}`);
  }
  addEvents(data) {
    return http.post(`/banner/`, data);
  }
  getEvents() {
    return http.get("/banner");
  }
  deleteEventBanner(id) {
    return http.delete(`/banner/${id}`);
  }
}
const mediaService = new mediaDataService();
export default mediaService;
